import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import Reveal from '../components/Reveal'
import SectionHeading from '../components/SectionHeading'
import { site } from '../data/site'
import { careerTimeline } from '../data/career'
import { partnerBenefits } from '../data/partners'
import { galleryImages } from '../data/gallery'
import { useSeo } from '../hooks/useSeo'

export default function HomePage() {
  useSeo({
    title: 'Em Whell Motorsport | #7 Production Sedan',
    description: 'Official site of Em Whell, driver of the #7 SSA Production Sedan based in Toowoomba, Queensland. Racing results, partnerships and appearances.',
    path: '/',
  })

  return (
    <>
      <section className="home-hero">
        <img className="home-hero-image" src="/assets/hero-action.jpg" alt="" width="2400" height="1800" loading="eager" fetchPriority="high" />
        <div className="home-hero-overlay" />
        {/* <div className="speed-lines" aria-hidden="true" /> */}
        <div className="site-container home-hero-grid">
          <Reveal className="home-hero-copy">
            <p className="eyebrow">{site.location} · {"#" + site.number + " " + site.className}</p>
            <h1><span>EM WHELL</span></h1>
            <p className="hero-tagline">Drive. Determination. <em>Heart.</em></p>
            <p className="hero-copy">Every race is an opportunity to learn, improve, and represent the people who believe in me.</p>
            <div className="hero-actions">
              <Link className="button button-primary" to="/contact">Let's Talk<ArrowRight size={16} /></Link>
              <button
                className="button button-outline"
                onClick={() =>
                  document.getElementById("aboutem")?.scrollIntoView({
                    behavior: "smooth",
                  })
                }
              >
                Discover
              </button>
            </div>
          </Reveal>

        </div>
        <div className="hero-rail"><div className="site-container"><span>EM WHELL MOTORSPORT</span><i /><span>NUMBER 7</span><i /><span>PRODUCTION SEDAN</span><i /><span>QUEENSLAND</span></div></div>
      </section>

      <section id="aboutem" className="section">
        <div className="site-container home-about-grid">
          <Reveal className="home-portrait"><img src="/assets/em-portrait.jpg" alt="Racing driver Em Whell" width="1080" height="1920" loading="lazy" /><div><strong>2019</strong><span>The journey began</span></div></Reveal>
          <Reveal>
            <p className="eyebrow">Meet Em</p>
            <h2>From junior sedans to the <span>senior field.</span></h2>
            <p className="lead">Em started racing at 14 and has developed through race wins, podiums, a championship title and the step into SSA Production Sedans.</p>
            <p className="muted">Her story is built on family support, hard work and the determination to keep learning every time the #7 rolls onto the track.</p>
            <Link className="text-link" to="/about">Read Em’s story <ArrowRight size={16} /></Link>
          </Reveal>
        </div>
      </section>

      <section className="image-feature">
        <img src="/assets/car-front.jpg" alt="Em Whell's number 7 Production Sedan racing on dirt" width="1920" height="1280" loading="lazy" />
        <div className="image-feature-overlay" />
        <div className="site-container image-feature-content">
          <Reveal>
            <p className="eyebrow">The car</p>
            <h2>Built for the road. <span>Reforged for dirt.</span></h2>
            <p>Production Sedans begin life as everyday rear-wheel-drive, naturally aspirated six-cylinder road cars before being transformed into purpose-built dirt racers. The result is close, fiercely competitive racing where driver skill and determination make the difference.</p>
          </Reveal>
        </div>
      </section>

      <section className="section section-dark">
        <div className="site-container">
          <SectionHeading eyebrow="The racing journey" title="Every season moves" highlight="forward." copy="A clear development path from Em’s first junior laps to the senior Production Sedan field." />
          <div className="timeline compact">
            {careerTimeline.slice(0, 4).map((item) => <Reveal key={item.year}><article><span>{item.year}</span><div><h3>{item.title}</h3><p>{item.description}</p></div></article></Reveal>)}
          </div>
          <Link className="button button-outline section-button" to="/racing">View racing journey</Link>
        </div>
      </section>

      <section className="partnership-preview">
        <div className="partnership-image" />
        <div className="partnership-copy">
          <Reveal>
            <p className="eyebrow">Partner with Em</p>
            <h2>More than a logo <span>on a race car.</span></h2>
            <p>Connect your business with a genuine racing story — photographed, shared and seen trackside across Queensland and beyond.</p>
            <ul>{partnerBenefits.slice(0, 4).map((benefit) => <li key={benefit}>{benefit}</li>)}</ul>
            <Link className="button button-dark" to="/partners">Partnership opportunities</Link>
          </Reveal>
        </div>
      </section>

      {/* <section className="section">
        <div className="site-container">
          <SectionHeading eyebrow="Trackside" title="The story in" highlight="pictures." copy="Racing, podiums, preparation and the people behind the #7." />
          <div className="gallery-preview">
            {galleryImages.slice(0, 4).map((image, index) => <figure key={image.src} className={index === 0 ? 'large' : ''}><img src={image.src} alt={image.alt} /><figcaption>{image.caption}</figcaption></figure>)}
          </div>
          <Link className="button button-outline section-button" to="/gallery">View full gallery</Link>
        </div>
      </section> */}
    </>
  )
}
